export enum RequestsPermissionsNotificationsSoundsType {
  UniformNormalBeep = 1,
  VoiceExplanation = 2
}
